export enum MealType {
  Popular = 'popular',
  Main = 'main',
  Side = 'side',
  Appetizer = 'appetizer',
  Beverage = 'beverage',
  Drink = 'drink',
  Dessert = 'dessert',
  Kids = 'kids',
}

export enum ShefSegmentTypes {
  Popular = 'shef_popular',
  PopularDishes = 'popular dishes',
}

export const MealTypeTitle = {
  [MealType.Popular]: 'Popular',
  [MealType.Main]: 'Mains',
  [MealType.Side]: 'Sides',
  [MealType.Appetizer]: 'Appetizers',
  [MealType.Drink]: 'Drinks',
  [MealType.Beverage]: 'Beverages',
  [MealType.Dessert]: 'Desserts',
  [MealType.Kids]: 'Kid Friendly',
  [ShefSegmentTypes.Popular]: 'Popular',
  [ShefSegmentTypes.PopularDishes]: 'Popular',
};

export const MealTypeOrder = Object.keys(MealTypeTitle);

export const MEAL_TYPE_CONTAINER_ID = 'browse-by-meal-type-container';

export const isPopularShefSegment = (segment: string): boolean =>
  segment.toLocaleLowerCase() === ShefSegmentTypes.Popular ||
  segment.toLocaleLowerCase() === ShefSegmentTypes.PopularDishes ||
  segment.toLocaleLowerCase() === MealType.Popular;

export const getMealTypeTitle = (segment: keyof typeof MealTypeTitle): string => {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Format sgement key
  const segmentTitle = segment.toLowerCase() as keyof typeof MealTypeTitle;
  return MealTypeTitle[segmentTitle] ?? segmentTitle;
};

export const getMealTypeId = (segment: keyof typeof MealType | string): string =>
  `meal-type-${isPopularShefSegment(segment) ? MealType.Popular : segment.toLowerCase()}-segment`;

export const getDataMealType = (mealType: string): string =>
  isPopularShefSegment(mealType) ? MealType.Popular : mealType;

export const formatShefSegments = (segments: string[]): string[] =>
  segments.map((segment) => (isPopularShefSegment(segment) ? MealType.Popular : segment.toLowerCase()));
